import { ITicketFile } from "./fetchTickets";
import ApiService from "../services/api";

export const uploadFile = async ({
  path,
  file,
}: {
  path: string;
  file: File[];
}): Promise<boolean> => {
  const apiService = new ApiService();
  const formData = new FormData();
  console.log(file);
  file.forEach((file) => formData.append("file", file));

  try {
    const response = await apiService.post<void>(
      `/attachment/${path}/upload`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    if (response.status < 400) {
      return true;
    } else {
      console.warn("Unexpected status code:", response.status);
      return false;
    }
  } catch (error) {
    console.error("Error uploading ticket image:", error);
    return false;
  }
};

export const fetchFiles = async (path: string): Promise<ITicketFile[]> => {
  const apiService = new ApiService();
  try {
    const response = await apiService.get<ITicketFile[]>(
      `/attachment/${path}`
    );
    if (response.status < 400) {
      return response.data;
    } else {
      console.warn("Unexpected status code:", response.status);
      return [];
    }
  } catch (error) {
    console.error("Error fetching ticket images:", error);
    return [];
  }
};

export const downloadFile = async (path: string): Promise<any> => {
  if (!path) return;
  const apiService = new ApiService();
  try {
    return await apiService.getAndDownloadFile(
      `/attachment/${path}/download`
    );
  } catch (error) {
    console.error("Error fetching ticket images:", error);
  }
};

export const removeFile = async (path: string, filename: string): Promise<boolean> => {
  const apiService = new ApiService();
  try {
    const response = await apiService.delete<void>(
      `/attachment/${path}/${filename}`
    );
    if (response.status < 400) {
      return true;
    } else {
      console.warn("Unexpected status code:", response.status);
      return false;
    }
  } catch (error) {
    console.error("Error removing ticket image:", error);
    return false;
  }
};
